export const PERF_EVENTS = {
  SLOW_INTERACTION: 'front.perf.interaction.slow',
} as const;

export const PERF_RELOAD_CAUSES = [
  'restore', 'prerender', 'navigation', 'after_chunk_failure',
  'app_reload', 'user_f5', 'unknown',
] as const;
export type tPerfReloadCause = typeof PERF_RELOAD_CAUSES[number];

export type tPerfBlockingScript = {
  invokerType?: string;
  sourceURL?: string;
  sourceFunctionName?: string;
  duration: number;
  forcedStyleAndLayoutDuration?: number;
  invoker?: string;
};

export type tSlowInteractionProps = {
  workspace_id?: string;
  interaction_id: number;
  interaction_start_time_ms: number;
  perf_interactions_total: number | null;
  interaction_type: string;
  duration_ms: number;
  input_delay_ms: number;
  processing_duration_ms: number;
  presentation_delay_ms: number;
  target_selector: string;
  route: '/workspace/chat' | '/workspace/funnel';
  perf_sample_rate: 0.1 | 1;
  suppressed_interactions: number;
  blocking_script?: tPerfBlockingScript;
};

export { PERF_DRAW_REASONS, PERF_REPLAY_ARMS } from 'src/lib/perf/perfArms.constants';
